import * as actionTypes from "../constants/ActionConstants";
import initialState from "./initialState";

export default function surveyReducer($$state = initialState, action = null) {
  const { type, data } = action;
  switch (type) {
    case actionTypes.SUBMIT_RESPONSE_SUCCESS: {
      return {
        ...$$state,
        submitted: true,
      };
    }

    case actionTypes.CREATE_EMPLOYEE_FAILURE: {
      return {
        ...$$state,
        created: false,
        status: action.error.status,
      };
    }

    case actionTypes.CREATE_EMPLOYEE_SUCCESS: {
      return {
        ...$$state,
        created: true,
        employee: {
          id: data.id,
          location: {
            name: data.location.name,
            employer: {
              name: data.location.employer.name,
            },
          },
        },
      };
    }

    default: {
      return $$state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/surveyReducer.js